export default "__VITE_ASSET__CltmY9fK__"